
export default {
  props: {
    socials: { type: Array, default: () => [] },
    negative: { type: Boolean, default: false },
  },
}
